export default __webpack_public_path__ + "241b3dc5d03660219ae85dfd6434f489.png";